import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      flex: 1,
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      borderRadius: theme.shape.borderRadius,

      '& $editable': {
        height: '100%',
        display: 'flex',
        flex: 1,
        alignItems: 'stretch',
        flexDirection: 'column',
        justifyContent: 'start',
        overflowY: 'auto',
        overflowX: 'hidden',
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2),
      },
      '&:not($hideAddInfo) $editable': {
        paddingRight: theme.spacing(11),
      },
    },
    hideAddInfo: {},

    editable: {
      flex: 1,
      lineHeight: 1.5,

      // TODO: refactor this
      minHeight: (props) =>
        props.noMinMaxHeight
          ? 'none !important'
          : props.shortExpanding
            ? '80px !important'
            : props.footerShown && props.promptImage
              ? '178px !important'
              : props.footerShown
                ? '210px !important'
                : '250px !important', //overrides styles of slate in case of placeholder
      maxHeight: (props) =>
        props.noMinMaxHeight || props.shortExpanding ? 'none !important' : '350px !important', //overrides styles of slate in case of placeholder

      // Truncate placeholder in small text areas (noMinMaxHeight)
      '& [data-slate-placeholder]': {
        whiteSpace: (props) => (props.noMinMaxHeight ? 'nowrap' : 'normal'),
        overflow: (props) => (props.noMinMaxHeight ? 'hidden' : 'visible'),
        textOverflow: (props) => (props.noMinMaxHeight ? 'ellipsis' : 'clip'),
        display: (props) => (props.noMinMaxHeight ? 'block' : 'inline'),
        maxWidth: (props) => (props.noMinMaxHeight ? '100%' : 'none'),
      },
    },
    disabled: {
      '& $editable': {
        backgroundColor: COLORS.gray.gray80,
        color: COLORS.gray.gray40,
      },
    },
  }),
  { name: 'InstructionsTextarea' }
);
